module.exports = __webpack_public_path__ + "img/07.37c8000c.png";